import React from 'react';
import { FD141, FD142 } from '../../../services/d204Api';
import { fmt } from '../helpers';

interface Tab4Props {
  details: Partial<FD141>[];
  lotDetails: Partial<FD142>[];
  selectedRow: number;
  isEditing: boolean;
  setSelectedRow: (idx: number) => void;
  onAddLot: () => void;
  onDeleteLot: (lotIdx: number) => void;
  onLotFieldChange: (lotIdx: number, key: keyof FD142, value: string) => void;
}

const Tab4LotDetail: React.FC<Tab4Props> = React.memo(({
  details, lotDetails: allLotDetails, selectedRow, isEditing, setSelectedRow,
  onAddLot, onDeleteLot, onLotFieldChange,
}) => {
  const selectedDetail = details[selectedRow];
  const lotDetails: Partial<FD142>[] = selectedDetail
    ? allLotDetails.filter(l => l.fd142_02 === selectedDetail.fd141_02)
    : [];

  return (
    <div className="form-section odd">
      <span className="section-tag">板/缸號明細</span>

      {/* FD141 summary grid (read-only) */}
      <div className="table-wrapper" style={{ marginBottom: 16 }}>
        <div className="table-scroll">
          <table className="data-table">
            <thead>
              <tr>
                <th style={{ width: 40 }} data-contract-field="fd141_02">項次</th>
                <th data-contract-field="fd141_11">等級</th>
                <th data-contract-field="fd141_13">單位</th>
                <th className="num" data-contract-field="fd141_15">入庫數量</th>
                <th data-contract-field="fd141_12">顏色</th>
              </tr>
            </thead>
            <tbody>
              {details.length === 0 ? (
                <tr><td colSpan={5} style={{ textAlign: 'center', color: '#999' }}>尚無明細</td></tr>
              ) : (
                details.map((d, i) => (
                  <tr key={i}
                    className={selectedRow === i ? 'selected' : ''}
                    onClick={() => setSelectedRow(i)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td>{d.fd141_02 || i + 1}</td>
                    <td>{d.fd141_11 || ''}</td>
                    <td>{d.fd141_13 || ''}</td>
                    <td className="num">{fmt(d.fd141_15 as number)}</td>
                    <td>{d.fd141_12 || ''}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* FD142 lot/roll grid */}
      {selectedDetail && (
        <>
          <div className="table-toolbar">
            <div className="left">
              <span style={{ fontSize: 13, color: '#595959' }}>
                板/缸號 ({lotDetails.length} 項) - 項次 {selectedDetail.fd141_02}
              </span>
            </div>
            <div className="right">
              {isEditing && (
                <>
                  <button className="btn btn-sm" onClick={onAddLot}>新增板號</button>
                </>
              )}
            </div>
          </div>
          <div className="table-wrapper">
            <div className="table-scroll">
              <table className="data-table">
                <thead>
                  <tr>
                    <th style={{ width: 40 }} data-contract-field="fd142_02">項次</th>
                    <th data-contract-field="fd142_03">板號</th>
                    <th data-contract-field="fd142_13">缸號</th>
                    {isEditing && <th style={{ width: 60 }} data-acceptance-non-field="row_actions">操作</th>}
                  </tr>
                </thead>
                <tbody>
                  {lotDetails.length === 0 ? (
                    <tr><td colSpan={isEditing ? 4 : 3} style={{ textAlign: 'center', color: '#999' }}>尚無板/缸號資料</td></tr>
                  ) : (
                    lotDetails.map((lot, li) => (
                      <tr key={li}>
                        <td>{lot.fd142_02 || selectedDetail.fd141_02}</td>
                        <td>{lot.fd142_03 || li + 1}</td>
                        <td>
                          <input type="text" style={{ width: '100%' }}
                            disabled={!isEditing}
                            value={lot.fd142_13 || ''}
                            onChange={e => onLotFieldChange(li, 'fd142_13', e.target.value)}
                            data-contract-field="fd142_13"
                          />
                        </td>
                        {isEditing && (
                          <td>
                            <button className="btn btn-sm btn-danger" onClick={() => onDeleteLot(li)}>刪除</button>
                          </td>
                        )}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
});

Tab4LotDetail.displayName = 'Tab4LotDetail';
export default Tab4LotDetail;
